import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { smallLeaseJudgeBasisJapanConfig } from './SmallLeaseJudgeBasisJapan.name';

/** 少額リース判定基準(日本基準)のENUM */
enum SmallLeaseJudgeBasisJapan {
  /** 300万円基準 */
  threeMillionYenBasis = '1',
  /** 5000米ドル基準 */
  fiveThousandDollarBasis = '2',
}

const SmallLeaseJudgeBasisJapanMap = new Map([
  ['1', SmallLeaseJudgeBasisJapan.threeMillionYenBasis],
  ['2', SmallLeaseJudgeBasisJapan.fiveThousandDollarBasis],
]);

const rawValueToSmallLeaseJudgeBasisJapan = rawValueToEnumWithDefault(
  SmallLeaseJudgeBasisJapanMap,
  SmallLeaseJudgeBasisJapan.threeMillionYenBasis,
);

const smallLeaseJudgeBasisJapanToDisplay = enumToNameWithDefault(
  SmallLeaseJudgeBasisJapan,
  smallLeaseJudgeBasisJapanConfig,
);

const smallLeaseJudgeBasisJapanToDisplayWithPrefix = enumToNameWithDefault(
  SmallLeaseJudgeBasisJapan,
  smallLeaseJudgeBasisJapanConfig,
  true,
);

export {
  SmallLeaseJudgeBasisJapan,
  rawValueToSmallLeaseJudgeBasisJapan,
  smallLeaseJudgeBasisJapanToDisplay,
  smallLeaseJudgeBasisJapanToDisplayWithPrefix,
};
